import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Cropper from "react-easy-crop";

export default function ImageCropper({ media, onZuschneiden }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState({});

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    console.log(croppedArea, croppedAreaPixels);
    setCroppedArea(croppedAreaPixels);
  };

  return (
    <React.Fragment>
      <div style={{ height: "400px", position: "relative" }}>
        <div>
          <Cropper
            image={`${media?.url}`}
            crop={crop}
            zoom={zoom}
            aspect={9 / 16}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
        <div className="controls">
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e) => {
              setZoom(e.target.value);
            }}
            className="zoom-range"
          />
        </div>
      </div>
      <Button
        variant="default"
        size="sm"
        onClick={() => onZuschneiden(croppedArea)}
      >
        Zuschneiden
      </Button>
    </React.Fragment>
  );
}
